<template  >
  <!-- Footer Section 06 -->
  <div
    class="footer-section"
    style="background-color:#F9F9F9;z-index:0;bottom: 0px;left: 0px;right: 0px;margin-bottom: 0px;"
  >
    <div class="container">
      <div class="footer-newsletter-section">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-xl-8">
            <div class="footer-newsletter-content">
              <h2>{{$root.footer_head.footer_text}}</h2>
            </div>
          </div>
          <div class>
            <div class="footer-newsletter-form">
              <div class="footer-logo">
                <img src="/assets/exported/All_logo.png" alt="created logo" />
              </div>
              <!--<div class="footer-newsletter-form">
                        <div class="footer-logo">
                            <img  src="/assets/exported/footer_logo_2.png" alt="">
                        </div>
                         <div class="footer-logo">
                            <img src="/assets/exported/footer_logo_3.png" alt="">
                        </div>
                         <div class="footer-logo">
                            <img  src="/assets/exported/footer_logo_1.png" alt="">
                        </div>
                         <div class="footer-logo">
                            <img  src="/assets/exported/footer_logo_1.png" alt="">
                        </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="row margin-decrese">
        <div class="col-lg-2 col-sm-4 col-6 col-margin">
          <div class="single-footer">
            <div class="footer-title cl_1">
              <a href="/" active-class="active" exact class="nav-link" style="style-list:none">
                <h6>{{$root.footer_text.footer_sub_text}}</h6>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-6 col-margin">
          <div class="single-footer">
            <div class="footer-title cl_2">
              <a href="/course_list" active-class="active" exact class="nav-link">
                <h6>{{$root.footer_text1.footer_sub_text1}}</h6>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-margin">
          <div class="single-footer">
            <div class="footer-title cl_3">
              <a href="/my_learning" active-class="active" exact class="nav-link">
                <h6>{{$root.footer_text2.footer_sub_text2}}</h6>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-margin">
          <div class="single-footer">
            <div class="footer-title cl_5">
              <a href="/edit_profile" active-class="active" exact class="nav-link">
                <h6>{{$root.footer_text3.footer_sub_text3}}</h6>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-margin">
          <div class="single-footer">
            <div class="footer-title cl_4">
              <h6>
                {{$root.footer_text4.footer_sub_text4}}
                <a
                  href="https://www.riseuplabs.com/"
                  style="text-decoration:underline"
                  target="_blank"
                >{{$root.footer_text5.footer_sub_text5}}</a>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-image">
      <img class="img-responsive intropage" src="/assets/exported/fotter_image.jpg" alt />
      <img class="img-responsive intropage mobile" src="/assets/exported/fotter_image_1.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.footer-section .margin-decrese {
  margin-bottom: 0px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: -80px;
}
.footer-image img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
}
.cl_4 {
  width: 235px;
  padding: 0.5rem 0rem;
}
.footer-title a:hover {
  font-size: 14.5px;
  color: #000 !important;
}
.footer-title a {
  color: #f26a11 !important;
}
/*
    This classes are for the directive. 
    For each element observed by our directive, the before-enter class is added.
  */
.before-enter {
  opacity: 0;
  transform: scale(1) translateY(200px);
  transition: all 1.5s ease-out;
}
/* 
    If the element intersects with the viewport, the before-enter class is added.
  */
.enter {
  opacity: 1;
  transform: scale(1) translateY(0px);
}
@media screen and (max-width: 3200px) {
  .footer-title {
    margin-top: 210%;
  }
}
@media screen and (max-width: 1920px) {
  .footer-title {
    margin-top: 150%;
  }
}
@media screen and (max-width: 1720px) {
  .footer-title {
    margin-top: 134%;
  }
}
@media screen and (max-width: 1600px) {
  .footer-title {
    margin-top: 132%;
  }
   .cl_4{
    width: 265px;
    padding: 0.5rem 0rem;
}
}
@media screen and (max-width: 1440px) {
  .footer-title {
    margin-top: 124%;
  }
   .cl_4{
    width: 265px;
    padding: 0.5rem 0rem;
}
}
@media screen and (max-width: 1340px) {
  .footer-title {
    margin-top: 116%;
  }
  .cl_4{
    width: 265px;
    padding: 0.5rem 0rem;
}
}

@media screen and (max-width: 1024px) {
  .footer-title {
    margin-top: 103%;
  }
}
@media screen and (max-width: 1000px) {
  .footer-section .margin-decrese {
    margin-bottom: 0px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: -30px;
  }
}
@media screen and (max-width: 992px) {
  .footer-title {
    margin-top: 70%;
  }
  .cl_3 {
    margin-left: -150px;
  }
  .cl_4 {
    margin-left: 100px;
    width: 275px;
    padding: 0.5rem 0rem;
  }
}
@media screen and (max-width: 840px) {
  .footer-title {
    margin-top: 56%;
  }
}
@media screen and (max-width: 767px) {
  .cl_1 {
    margin-left: -50px;
  }
  .cl_2 {
    margin-left: 120px;
  }
  .cl_3 {
    margin-left: -160px;
  }
  .cl_4 {
    margin-left: 110px;
    width: 235px;
    padding: 0.5rem 0rem;
  }
  .cl_5 {
    margin-left: -10px;
  }
  .footer-title {
    margin-top: 68%;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 660px) {
  .footer-title {
    margin-top: 60%;
  }
}
@media screen and (max-width: 630px) {
  .footer-title h6 {
    font-size: 10px;
  }
  .cl_1 {
    margin-left: -10px;
  }
  .cl_2 {
    margin-left: 120px;
  }
  .cl_3 {
    margin-left: -150px;
  }
  .cl_4 {
    margin-left: 110px;

    width: 235px;
    padding: 0.5rem 0rem;
  }
  .cl_5 {
    margin-left: 10px;
  }
  .footer-title {
    margin-top: 55%;
  }
}
@media screen and (max-width: 575px) {
  .footer-title {
    margin-top: 0%;
  }
  .cl_1 {
    margin-left: -20px;
  }
  .cl_2 {
    margin-left: 110px;
  }
  .cl_3 {
    margin-left: 240px;
  }
  .cl_4 {
    margin-left: 110px;
    margin-top: 18%;
    width: 235px;
    padding: 0.5rem 0rem;
  }
  .cl_5 {
    margin-left: 120px;
  }
  .footer-section .margin-decrese {
    margin-bottom: 0px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: 40px;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 480px) {
  .footer-title {
    margin-top: 35%;
  }
  .footer-logo img {
    margin-left: 5px;
  }
  .footer-section .margin-decrese {
    margin-left: 30px;
  }
  .cl_5 {
    right: 0;
    margin-left: 0;
    margin-top: 24.5%;
    margin-right: 8px;
  }
  .cl_3 {
    left: 0;
    margin-left: 98px;
    margin-top: 24%;
  }
  .cl_1 {
    margin-top: 48%;
    left: 0;
    margin-left: -38px;
  }
  .cl_4 {
    margin-left: 70px;
    text-align: center;
    margin-top: 39%;
    width: 240px;
  }
  .cl_2 {
    margin-left: 0px;
    right: 20;
    margin-right: 35px;
    margin-top: 48.4%;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 440px) {
  .footer-title {
    margin-top: 35%;
  }
  .footer-section .margin-decrese {
    margin-left: 30px;
  }
  .cl_5 {
    right: 15px;
    margin-left: 0;
    margin-top: 22.5%;
    margin-right: 8px;
  }
  .cl_3 {
    left: 0;
    margin-left: -25px;
    margin-top: 31%;
  }
  .cl_1 {
    margin-top: 45.4%;
    left: 0;
    margin-left: -25px;
  }
  .cl_4 {
    margin-left: 30px;
    text-align: center;
    margin-top: 39%;
    width: 240px;
  }
  .cl_2 {
    margin-left: 0px;
    right: 15px;
    margin-right: 34px;
    margin-top: 60.4%;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 380px) {
  .footer-section .margin-decrese {
    margin-left: 30px;
  }
  .cl_5 {
    margin-left: 0;
    margin-top: 21%;
    margin-right: -5px;
  }
  .cl_3 {
    left: 0;
    margin-left: -32px;
    margin-top: 31.4%;
  }
  .cl_1 {
    margin-top: 42%;
    left: 0;
    margin-left: -32px;
  }
  .cl_4 {
    margin-left: 8px;
    text-align: center;
    margin-top: 36%;
    width: 240px;
  }
  .cl_2 {
    margin-left: 0px;
    right: 6px;
    margin-right: 30px;
    margin-top: 62.4%;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 380px) {
  .footer-section .margin-decrese {
    margin-left: 30px;
  }
  .cl_4 {
    margin-left: 4%;
    text-align: center;
    margin-top: 39%;
    width: 235px;
    padding: 0.5rem 0rem;
  }

  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 360px) {
  .footer-section .margin-decrese {
    margin-left: 30px;
  }

  .cl_4 {
    margin-left: 0%;
    text-align: center;
    margin-top: 39%;
    width: 235px;
    padding: 0.5rem 0rem;
  }

  .footer-title h6 {
    font-size: 12px;
  }
}
@media screen and (max-width: 340px) {
  .footer-section .margin-decrese {
    margin-left: 30px;
  }
  .cl_4 {
    margin-left: -8px;
    text-align: center;
    margin-top: 40%;
    width: 235px;
    padding: 0.5rem 0rem;
  }
  .footer-title h6 {
    font-size: 12px;
  }
}
</style>